import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['option1Content', 'option2Content', 'option3Content', 'option4Content']

  connect() {
    this.element.addEventListener('toggle:change', this.handleToggleChange.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('toggle:change', this.handleToggleChange.bind(this))
  }

  handleToggleChange(event) {
    const { selectedOption } = event.detail

    if (selectedOption === 'option1') {
      this.showOption1Content()
    } else if (selectedOption === 'option2') {
      this.showOption2Content()
    } else if (selectedOption === 'option3') {
      this.showOption3Content()
    } else if (selectedOption === 'option4') {
      this.showOption4Content()
    }
  }

  showOption1Content() {
    this.hideAllContent()
    if (this.hasOption1ContentTarget) {
      this.option1ContentTarget.classList.remove('hidden')
    }
  }

  showOption2Content() {
    this.hideAllContent()
    if (this.hasOption2ContentTarget) {
      this.option2ContentTarget.classList.remove('hidden')
    }
  }

  showOption3Content() {
    this.hideAllContent()
    if (this.hasOption3ContentTarget) {
      this.option3ContentTarget.classList.remove('hidden')
    }
  }

  showOption4Content() {
    this.hideAllContent()
    if (this.hasOption4ContentTarget) {
      this.option4ContentTarget.classList.remove('hidden')
    }
  }

  hideAllContent() {
    if (this.hasOption1ContentTarget) {
      this.option1ContentTarget.classList.add('hidden')
    }
    if (this.hasOption2ContentTarget) {
      this.option2ContentTarget.classList.add('hidden')
    }
    if (this.hasOption3ContentTarget) {
      this.option3ContentTarget.classList.add('hidden')
    }
    if (this.hasOption4ContentTarget) {
      this.option4ContentTarget.classList.add('hidden')
    }
  }
}
